import {AreaDefaults, AreaSharedTriggerConfig, BeaconTrigger, WiFiApTrigger} from "../../components/types";
import {cloneCueBeaconTriggers, cloneCueWiFiTriggers} from "./cueTriggerDialogUtils";

export type CueTriggerSet = {
    beaconTriggers: BeaconTrigger[];
    wiFiTriggers: WiFiApTrigger[];
};

export type SharedTriggerConfig = AreaSharedTriggerConfig;

export const fromLegacySharedTriggerConfig = (sharedTrigger?: SharedTriggerConfig): CueTriggerSet => {
    if (!sharedTrigger) {
        return {beaconTriggers: [], wiFiTriggers: []};
    }
    if (sharedTrigger.type === "beacon" && sharedTrigger.beacon?.macAddr) {
        return {
            beaconTriggers: [{
                id: "cue_beacon",
                type: "Beacon",
                macAddr: sharedTrigger.beacon.macAddr,
                majorId: "",
                minorId: "",
                uuid: sharedTrigger.beacon.uuid
            }],
            wiFiTriggers: []
        };
    }
    if (sharedTrigger.type === "wifi" && sharedTrigger.wifi?.name) {
        return {
            beaconTriggers: [],
            wiFiTriggers: [{
                id: "cue_wifi",
                type: "WiFiAP",
                name: sharedTrigger.wifi.name
            }]
        };
    }
    return {beaconTriggers: [], wiFiTriggers: []};
};

export const extractCueTriggerSet = (
    defaults?: AreaDefaults,
    firstSpotTriggers?: {beaconTriggers?: BeaconTrigger[]; wiFiTriggers?: WiFiApTrigger[]}
): CueTriggerSet => {
    const beaconTriggers = cloneCueBeaconTriggers(defaults?.beaconTriggers);
    const wiFiTriggers = cloneCueWiFiTriggers(defaults?.wiFiTriggers);
    if (beaconTriggers.length > 0 || wiFiTriggers.length > 0) {
        return {beaconTriggers, wiFiTriggers};
    }

    const legacy = fromLegacySharedTriggerConfig(defaults?.sharedTrigger);
    if (legacy.beaconTriggers.length > 0 || legacy.wiFiTriggers.length > 0) {
        return legacy;
    }

    return {
        beaconTriggers: cloneCueBeaconTriggers(firstSpotTriggers?.beaconTriggers),
        wiFiTriggers: cloneCueWiFiTriggers(firstSpotTriggers?.wiFiTriggers)
    };
};

export const applyCueTriggerSetToSpot = (triggerSet: CueTriggerSet) => ({
    beaconTriggers: cloneCueBeaconTriggers(triggerSet.beaconTriggers),
    wiFiTriggers: cloneCueWiFiTriggers(triggerSet.wiFiTriggers)
});

export const hasCueTriggers = (triggerSet: CueTriggerSet) => {
    return triggerSet.beaconTriggers.length > 0 || triggerSet.wiFiTriggers.length > 0;
};

export const toLegacySharedTriggerConfig = (triggerSet: CueTriggerSet): SharedTriggerConfig => {
    if (triggerSet.beaconTriggers.length === 1 && triggerSet.wiFiTriggers.length === 0) {
        return {
            type: "beacon",
            beacon: {
                macAddr: triggerSet.beaconTriggers[0].macAddr || "",
                uuid: triggerSet.beaconTriggers[0].uuid
            }
        };
    }
    if (triggerSet.wiFiTriggers.length === 1 && triggerSet.beaconTriggers.length === 0) {
        return {
            type: "wifi",
            wifi: {
                name: triggerSet.wiFiTriggers[0].name || ""
            }
        };
    }
    return {
        type: "none"
    };
};
